import { UHID_PUSH_CONFIG } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Res = { success: boolean; error?: string };

export default (config: { prefix: string; startfrom: number }): Promise<Res> => {
    return fetchWithRefresh(UHID_PUSH_CONFIG(), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(config),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to UHID_PUSH_CONFIG');
        }
    });
};
